// extracted by mini-css-extract-plugin
export var askAiIcon = "_oe-k";
export var category = "_oe-a";
export var categoryHeader = "_oe-f";
export var container = "_oe-0";
export var group = "_oe-b";
export var groupItems = "_oe-g";
export var groupSeparator = "_oe-l";
export var highlight = "_oe-8";
export var loading = "_oe-1";
export var noResults = "_oe-3";
export var placeholder = "_oe-2";
export var resultContent = "_oe-5";
export var resultIcon = "_oe-d";
export var resultItem = "_oe-h";
export var resultMeta = "_oe-9";
export var resultSubtitle = "_oe-7";
export var resultSuffix = "_oe-j";
export var resultTitle = "_oe-6";
export var resultsList = "_oe-4";
export var searchGroup = "_oe-e";
export var selected = "_oe-i";
export var subgroup = "_oe-c";